import styled from "styled-components";

import { PageHeaderSubtitleContainer } from "@Console/components/molecules/PageHeader/components/atoms/Subtitle/styles";
import { PageHeaderTitleContainer } from "@Console/components/molecules/PageHeader/components/atoms/Title/styles";

export const ConsoleOrganizationsPageContainer = styled.div`
  max-width: 1000px;
  width: 100%;

  margin: 5rem auto 0 auto;
  padding: 0 1rem;

  @media (max-width: 600px) {
    margin-top: 3rem;
  }

  ${PageHeaderTitleContainer} {
    font: 600 1.5rem/1.875rem "Inter";
  }

  ${PageHeaderSubtitleContainer} {
    font: 400 0.875rem/1.3125rem "Inter";
  }

  > .loader {
    width: fit-content;
    margin: 0 auto;
  }

  .MuiDataGrid-columnHeadersInner:has(> div[role="row"]) {
    div[role="row"] {
      width: 100% !important;
    }
  }
`;
